import { render, staticRenderFns } from "./viewAddress.vue?vue&type=template&id=9bb852dc&scoped=true&"
import script from "./viewAddress.vue?vue&type=script&lang=js&"
export * from "./viewAddress.vue?vue&type=script&lang=js&"
import style0 from "./viewAddress.vue?vue&type=style&index=0&id=9bb852dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb852dc",
  null
  
)

export default component.exports